module.exports = __webpack_public_path__ + "static/tactics_collection_hazena-861e0129afd26c5d56ac0cf83c156753.mp4";